import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image";

const FeaturedBoards = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        sort: { order: DESC, fields: frontmatter___created }
        limit: 4
        filter: { fields: { slug: { ne: "privacy-policy" } } }
      ) {
        edges {
          node {
            frontmatter {
              title
              category
              featured_image {
                img {
                  childImageSharp {
                    fluid(maxWidth: 550, quality: 90) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `);
  //   console.log(data.allMarkdownRemark);
  return (
    <>
      <h3 className="bg-indigo-700 text-white text-center text-lg px-4 py-2 font-bold tracking-wider m-0">
        Featured Boards
      </h3>
      <ul className="divide-y">
        {(data.allMarkdownRemark.edges || []).map(({ node }, i) => (
          <li key={i} className="block py-2 sm:flex last:mb-0 last:pb-0">
            <Link
              to={`/${node.frontmatter.category}s/${node.fields.slug}`}
              className="w-full h-20 hidden lg:block justify-center sm:w-auto sm:mr-2 focus:outline-none focus:shadow-outline"
            >
              <Img
                className="h-full w-24"
                fluid={
                  node.frontmatter.featured_image.img.childImageSharp.fluid
                }
              />
            </Link>
            <Link
              to={`/${node.frontmatter.category}s/${node.fields.slug}`}
              className="hover:text-indigo-700 transition-all duration-300 text-lg block lg:text-base focus:outline-none focus:text-indigo-700"
            >
              {node.frontmatter.title}
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
};

export default FeaturedBoards;
